import AirFilterHealth from "@features/home-health/components/AirFilterHealth";
import ExternalPlumbingFreezeHealth from "@features/home-health/components/ExternalPlumbingFreezeHealth";
import LeakHealth from "@features/home-health/components/LeakHealth";
import { Box, Grid } from "@mui/material";
import { HealthCheckType } from '../types';
import config from "@lib/config";
import {FC} from "react";

const HealthChecks = () => {
  const healthCheckComponents: Partial<Record<HealthCheckType, FC>> = {
    [HealthCheckType.LEAK]: LeakHealth,
    [HealthCheckType.AIR_FILTER]: AirFilterHealth,
    [HealthCheckType.EXTERNAL_PLUMBING_FREEZE_WARNING]: ExternalPlumbingFreezeHealth,
  };

  return (
    <Box component="div">
      <Grid
        container
        columns={{ xs: 1, sm: 1, md: 2 }}
      >
        {config.OBSERVED_HEALTHCHECKS.map((healthCheckType: HealthCheckType) => {
          const HealthCheckComponent = healthCheckComponents[healthCheckType];

          return HealthCheckComponent ? (
            <Grid sx={{ p: 1 }} xs={1} item key={healthCheckType}>
              <HealthCheckComponent />
            </Grid>
          ) : null;
        })}
      </Grid>
    </Box>
  );
}

export default HealthChecks;
